import { defineMessages } from "react-intl";
const messages = defineMessages({
    aiDiscoverDemoTitle: {
        id: "app.aiDiscover.demo.title.text",
        defaultMessage: "Discover Demo",
    },
    aiDiscoverDemoSubtitle: {
        id: "app.aiDiscover.demo.subtitle.text",
        defaultMessage: "Experience the full platform with sample data",
    },
});
export default messages;
